import React from 'react'
import LearnPuberty from '../../molecules/learnPuberty/learnPuberty'
import EducationalVideos from '../../molecules/educationalVideos/educationalVideos'
import InformativeArticles from '../../molecules/informativeArticles/informativeArticles'
import DownloadableLearn from '../../molecules/downloadableLearn/downloadableLearn'

function ContentLearn() {
  return (
    <>
      <LearnPuberty />
      <EducationalVideos />
      <InformativeArticles />
      <DownloadableLearn />
    </>
  )
}

export default ContentLearn
